<sc-flex fitHeight stretchContent>
    <div class="info-column">
        <sc-flex vertical stretchContent>
            <div class="icon-container">
                <i class="fa-light fa-sharp fa-check-circle"></i>
            </div>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-read-only-field labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.numberPlate" [value]="numberPlate"></sc-read-only-field>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-read-only-field labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.driver" [value]="driver"></sc-read-only-field>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-read-only-field labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.carrier" [value]="carrier"></sc-read-only-field>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-read-only-field labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.referenceNumber" [value]="orderReference"></sc-read-only-field>
        </sc-flex>
    </div>
    <sc-content-spacer [double]="true"></sc-content-spacer>
    <sc-flex-fitting-content>

        <ng-container *ngIf="gatekeeperMandatory">
            <div class="gatekeeper-hint">
                <sc-padding>
                  <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.hint"></sc-dictionary-label>
                </sc-padding>
            </div>
            <sc-content-spacer vertical></sc-content-spacer>
        </ng-container>

        <ng-container *ngIf="isUsingSmartphone">
            <div class="smartphone-hint">
                <sc-padding>
                  <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.description"></sc-dictionary-label>
                </sc-padding>
            </div>
            <sc-content-spacer vertical></sc-content-spacer>
        </ng-container>

        <ng-container *ngFor="let hint of hintDrivers">
            <div class="driver-hint">
                <sc-padding>
                    <sc-dictionary-label [dictionaryKey]="hint"></sc-dictionary-label>
                </sc-padding>
            </div>
            <sc-content-spacer vertical></sc-content-spacer>
        </ng-container>

    </sc-flex-fitting-content>
</sc-flex>
